/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The PriceAndProcessorIds model module.
 * @module model/PriceAndProcessorIds
 * @version v0
 */
export default class PriceAndProcessorIds {
  /**
   * Constructs a new <code>PriceAndProcessorIds</code>.
   * @alias module:model/PriceAndProcessorIds
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>PriceAndProcessorIds</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/PriceAndProcessorIds} obj Optional instance to populate.
   * @return {module:model/PriceAndProcessorIds} The populated <code>PriceAndProcessorIds</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new PriceAndProcessorIds();
      if (data.hasOwnProperty('idsByPaymentProcessor'))
        obj.idsByPaymentProcessor = ApiClient.convertToType(data['idsByPaymentProcessor'], {'String': 'String'});
      if (data.hasOwnProperty('price'))
        obj.price = ApiClient.convertToType(data['price'], 'Number');
    }
    return obj;
  }
}

/**
 * @member {Object.<String, String>} idsByPaymentProcessor
 */
PriceAndProcessorIds.prototype.idsByPaymentProcessor = undefined;

/**
 * @member {Number} price
 */
PriceAndProcessorIds.prototype.price = undefined;

